var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiRequestsService } from '@base/api/api.gateway';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HelpersService, AuthService, UserService } from '@base/shared/services';
import { TranslateService } from '@ngx-translate/core';
import { get, orderBy } from 'lodash';
var NewNoteWalkthroughModalContent = /** @class */ (function () {
    //@Input() contractWalkthroughId;
    function NewNoteWalkthroughModalContent(activeModal, router, navigator, activeRoute, formBuilder, api, helpers, translate, authService, accountService) {
        this.activeModal = activeModal;
        this.router = router;
        this.navigator = navigator;
        this.activeRoute = activeRoute;
        this.formBuilder = formBuilder;
        this.api = api;
        this.helpers = helpers;
        this.translate = translate;
        this.authService = authService;
        this.accountService = accountService;
        this.loading = false;
        this.album = {};
        this.formMode = 'save';
        this.rootContractId = this.accountService.account.contract.contractId;
        this.readOnly = false;
        this.subscriptions = {};
        this.isQuick = false;
        this.isMobile = false;
    }
    /** TODO: use note.component */
    NewNoteWalkthroughModalContent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sectionId = this.activeRoute.snapshot.paramMap.get('id');
                        this.accountId = this.authService.accountId;
                        //this.contractId = this.activeRoute.snapshot.params.projectId;
                        this.walkthroughSectionNoteId = this.activeRoute.snapshot.params.walkthroughSectionNoteId || this.data.walkthroughSectionNoteId;
                        this.contractWalkthroughId = this.data.contractWalkthroughId;
                        this.calendarDate = this.activeRoute.snapshot.queryParams.calendarDate;
                        this.queryParams = this.activeRoute.snapshot.queryParams;
                        return [4 /*yield*/, this.listContracts()];
                    case 1:
                        _a.sent();
                        if (this.walkthroughSectionNoteId) {
                            this.formMode = 'edit';
                            this.contractWalkthroughsNote();
                        }
                        else {
                            this.bootstrapForm({});
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    NewNoteWalkthroughModalContent.prototype.listContracts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var payload, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = { parentContractId: this.rootContractId };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.contracts.getListByParentId(payload).toPromise()];
                    case 2:
                        res = _a.sent();
                        this.contracts = orderBy(res.data, 'displayName') || [];
                        this.contracts.unshift({
                            contractId: '',
                            displayName: this.translate.instant('none')
                        });
                        return [2 /*return*/, this.contracts];
                    case 3:
                        error_1 = _a.sent();
                        this.helpers.errorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get Note by Note Id
     * @params(contractWalkthroughId, walkthroughSectionNoteId)
     */
    NewNoteWalkthroughModalContent.prototype.contractWalkthroughsNote = function () {
        var _this = this;
        this.api.walkthroughServices.getContractWalkthroughNote(this.contractWalkthroughId, this.walkthroughSectionNoteId)
            .then(function (result) {
            _this.noteData = result.contractWalkthroughNoteListItem || {};
            _this.bootstrapForm(_this.noteData);
        })
            .catch(function (err) {
            _this.helpers.errorMessage(err);
            _this.cancel();
        });
    };
    /**
     * create / edit current note
     */
    NewNoteWalkthroughModalContent.prototype.saveOrUpdate = function (_a) {
        var value = _a.value, valid = _a.valid;
        if (!valid) {
            this.helpers.setFormError(this.noteForm, false);
            this.noteForm.controls['relatedContract'].setErrors(null);
            return;
        }
        this.loading = true;
        var payload;
        if (this.formMode === 'edit') {
            payload = [
                {
                    'op': 'replace',
                    'path': '/note',
                    'value': value.note
                }
            ];
            payload.push({
                'op': 'replace',
                'path': '/referenceContractId',
                'value': "" + (get(value, 'relatedContract.contractId') || '')
            });
            this.editForm(payload);
        }
        else {
            payload = {
                note: value.note,
                referenceContractId: "" + (get(value, 'relatedContract.contractId') || '')
            };
            this.saveForm(payload);
        }
    };
    NewNoteWalkthroughModalContent.prototype.editForm = function (payload) {
        var _this = this;
        this.api.walkthroughServices.pathContractWalkthroughNote(this.contractWalkthroughId, this.walkthroughSectionNoteId, payload)
            .then(function (result) {
            var _label = 'common.successfullyUpdated';
            var _title = _this.translate.instant('notes.note');
            var _msg = _this.translate.instant(_label, { section: _title });
            _this.helpers.successMessage('', _msg);
            _this.cancel();
        })
            .catch(function (err) {
            _this.loading = false;
            _this.helpers.errorMessage(err);
            _this.helpers.setFormError(_this.noteForm, false);
        });
    };
    NewNoteWalkthroughModalContent.prototype.saveForm = function (payload) {
        var _this = this;
        this.api.walkthroughServices.createContractWalkthroughNotes(this.contractWalkthroughId, payload)
            .then(function (result) {
            var _label = 'common.successfullyCreated';
            var _title = _this.translate.instant('notes.note');
            var _msg = _this.translate.instant(_label, { section: _title });
            _this.helpers.successMessage('', _msg);
            _this.cancel();
        })
            .catch(function (err) {
            _this.loading = false;
            _this.helpers.errorMessage(err);
            _this.helpers.setFormError(_this.noteForm, false);
        });
    };
    NewNoteWalkthroughModalContent.prototype.compareObjects = function (o1, o2) {
        return o1.contractId === o2.contractId;
    };
    /**
     * Initialize photo form
     */
    NewNoteWalkthroughModalContent.prototype.bootstrapForm = function (data) {
        var contract = this.contracts.find(function (item) {
            return item.contractId === get(data, 'referenceContract.contractId') || '';
        });
        this.noteForm = this.formBuilder.group({
            note: [data.note || '', [Validators.required]],
            relatedContract: [contract || '']
        });
    };
    NewNoteWalkthroughModalContent.prototype.goBack = function () {
        this.closeModal();
    };
    /**
     * Cancel note creation / edition
     */
    NewNoteWalkthroughModalContent.prototype.cancel = function () {
        this.closeModal({});
    };
    /**
     * Close current Modal
     * @param {[type]} result [description]
     */
    NewNoteWalkthroughModalContent.prototype.closeModal = function (result) {
        this.activeModal.close(result);
    };
    return NewNoteWalkthroughModalContent;
}());
export { NewNoteWalkthroughModalContent };
